/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Config_SavedInputs */



/**
* | output |
* | --- |
* | "All changes saved" |
*
* @param {Config_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const config_saved = /** @type {((inputs?: Config_SavedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Config_SavedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les modifications enregistrées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los cambios guardados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as alterações salvas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le modifiche salvate")
	return /** @type {LocalizedString} */ ("All changes saved")
});